import {
  BASE_URL,
  BUSINESS_NAME,
  BUSINESS_CONTACT_PHONE,
} from "@/core/constants/business";

export const META = {
  title: `Our Locations | ${BUSINESS_NAME} Cannabis Dispensary`,
  meta_description: `Visit ${BUSINESS_NAME} cannabis dispensary at our Washington DC location. Premium cannabis products and knowledgeable staff ready to assist you 7 days a week.`,
  canonicalUrl: "/locations",
  keywords: `${BUSINESS_NAME} location, DC cannabis dispensary, weed dispensary Washington DC, cannabis store location, marijuana shop DC, Connecticut Ave dispensary`,
};

export const generateLocationsRichSnippet = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Store",
    name: `${BUSINESS_NAME} Cannabis Dispensary`,
    image: `${BASE_URL}/images/street-lawyer-services-dc-dispensary-entrance.jpg`,
    "@id": `${BASE_URL}/locations/#store`,
    url: `${BASE_URL}/locations`,
    telephone: BUSINESS_CONTACT_PHONE,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3400 Connecticut Avenue NW",
      addressLocality: "Washington",
      addressRegion: "DC",
      postalCode: "20008",
      addressCountry: "US",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 38.9332,
      longitude: -77.058606,
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "10:00",
        closes: "20:00",
      },
    ],
    sameAs: [
      "https://www.instagram.com/streetlawyerservices/",
      "https://www.youtube.com/@streetlawyerpodcast",
    ],
  };
};
